import React, { useEffect } from "react";
import styles from "./index.module.scss";
import { InputText } from "primereact/inputtext";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "primereact/hooks";
import ButtonC from "../../../button";

export default function SearchComponent({
  setShowSearch,
  searchRef
}: {
  setShowSearch?: React.Dispatch<React.SetStateAction<boolean>>;
  searchRef?: React.RefObject<any>;
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, debouncedSearchValue, setSearchValue] = useDebounce(
    searchParams.get("searchText") || "",
    500
  );

  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (debouncedSearchValue) {
      newSearchParams.set("searchText", debouncedSearchValue);
    } else {
      newSearchParams.delete("searchText");
    }
    setSearchParams(newSearchParams);
  }, [debouncedSearchValue, setSearchParams]);

  return (
    <div className={styles.searchWrap}>
      <div className={styles.search}>
        <InputText
          className={styles.inputBox}
          tabIndex={28}
          placeholder="Search"
          name="search"
          type="text"
          size="large"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          required
        />
        <img
          src="/images/close.svg"
          alt=""
          width={19}
          height={19}
          className={styles.close}
          onClick={() => {
            setSearchValue("");
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete("searchText");
            setSearchParams(newSearchParams);
          }}
        />
      </div>
      <ButtonC
        disabled={false}
        type="button"
        label="Close"
        size="large"
        tabIndex={29}
        className={styles.btn}
        onClick={() => {
          if (setShowSearch) {
            setShowSearch(false);
          }
          if (searchRef) {
            // @ts-ignore
            searchRef?.current?.hide();
          }
        }}
      />
    </div>
  );
}
